import React from 'react';
import { useParams } from "@remix-run/react";
import { Header } from './Header';
import { usePath, useVideoConfig } from '../../config/VideoAppContext';
import { isSelectedTopicRoute } from '../../pages/Topic/TopicPage.route';
import { useDataState } from '../../providers/DataProvider/DataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const TopicHeader = ({
  route: currentRoute
}) => {
  const {
    header
  } = useVideoConfig();
  const {
    topicPath,
    homePath
  } = usePath();
  const {
    topicState: {
      topics
    }
  } = useDataState();
  const {
    topicName
  } = useParams();
  const homeLink = {
    title: 'Home',
    path: homePath,
    isActive: route => route.pageId === 'home'
  };
  const topicLinks = topics.map(topic => ({
    title: topic.title,
    path: topicPath(topic.title),
    isActive: route => isSelectedTopicRoute(route, topic.title, topicName ?? '')
  }));
  const config = {
    menuEntries: header.menuEntries,
    loginEntries: header.loginEntries,
    mainNavigation: [],
    secondLevelNavigation: {
      links: [homeLink, ...topicLinks]
    }
  };
  return /*#__PURE__*/_jsx(Header, {
    config: config,
    route: currentRoute
  });
};